import React, { Component } from 'react';
import Slider from 'react-slick';
import ArrowButton from '../../../ui/ArrowButton';
import styles from './Slideshow.module.scss';
import { TweenLite } from 'gsap';
class Slideshow extends Component {
  state = {
    currentImage: null,
  };

  slickOptions = {
    dots: true,
    infinite: false,
    draggable: true,
    speed: 1500,
    cssEase: 'cubic-bezier(.9, 0, .3, 1)',
    nextArrow: <ArrowButton direction={'right'} />,
    prevArrow: <ArrowButton direction={'left'} />,
    beforeChange: (oldIndex, newIndex) => {
      this.setState({ currentImage: this.props.images[newIndex] });
    },
  };

  componentDidMount() {
    // console.log(this.props.images);
    this.setState({ currentImage: this.props.images[0] });
    this.animateIn();
  }

  createRef = el => (this.slideshowref = el);

  animateOut = () => {
    TweenLite.to(this.slideshowref, 0.65, {
      x: '100%',
      ease: Expo.easeInOut,
      onComplete: this.props.handleTourStopDetailClosed,
    });
  };

  animateIn = () => {
    TweenLite.set(this.slideshowref, { x: '100%', force3D: true });
    TweenLite.to(this.slideshowref, 1, { x: '0%', ease: Expo.easeInOut });
  };

  getSliderOrImage = images => {
    if (images.length <= 1) {
      return (
        <img
          className={styles.image}
          src={images[0].sizes.large}
          alt={images[0].alt}
        />
      );
    } else {
      return (
        <Slider className={`tour-slick`} {...this.slickOptions}>
          {images.map(image => {
            return (
              <img
                key={image.sizes.large}
                src={image.sizes.large}
                alt={image.caption}
              />
            );
          })}
        </Slider>
      );
    }
  };

  render() {
    const {
      images,
      body,
      title,
      isOpen,
      handleTourStopDetailClosed,
    } = this.props;

    return (
      <div
        ref={this.createRef}
        className={`${styles.container} slide-in-${status}`}
      >
        <div
          className={isOpen ? styles.backBarOpen : styles.backBarClosed}
          onClick={this.animateOut}
        >
          <span className={styles.backTitle}>
            <svg
              width="27"
              height="24"
              viewBox="0 0 27 24"
              className={styles.arrow}
            >
              <title>Left Arrow</title>
              <polygon points="3.891 10.946 26.267 10.946 26.267 12.592 3.917 12.592 13.92 22.171 12.776 23.267 .755 11.756 12.776 .245 13.92 1.341" />
            </svg>
            {title}
          </span>
        </div>
        <div className={styles.header}>
          <div className={styles.headerBg}>{this.getSliderOrImage(images)}</div>
        </div>
        <div className={styles.teaserContainer}>
          <div className={styles.tourStopBodyContainer}>
            {title && <h3 dangerouslySetInnerHTML={{ __html: title }} />}
            {images.length <= 1 && body ? (
              <div
                className={styles.tourStopBody}
                dangerouslySetInnerHTML={{ __html: body }}
              />
            ) : (
              <div className={styles.tourStopBody}>
                {this.state.currentImage && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: this.state.currentImage.caption,
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Slideshow;



// WEBPACK FOOTER //
// ./src/components/tour/details/views/Slideshow.js